import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SwalToastService } from './swal.service';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IPDQRequest } from '../interfaces/PDQ/IPDQRequest';
import {
  IPDQmResponse,
  IPDQResponse,
  IPDQv3Response,
} from '../interfaces/PDQ/IPDQResponse';

@Injectable({ providedIn: 'root' })
export class PDQService {
  constructor(
    private readonly _http: HttpClient,
    private readonly swalToastService: SwalToastService
  ) {}

  pdqiti21(ip: string, port: number, value: string): Observable<IPDQResponse> {
    value = value.replace(/\r?\n/g, '\r');
    const pdq: IPDQRequest = {
      ip: ip,
      port: port,
      message: btoa(value),
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.post<IPDQResponse>(
      `${environment.BACKEND_URL}PDQv2/SendSingle/ITI21`,
      pdq,
      {
        headers,
      }
    );
  }

  pdqiti22(ip: string, port: number, value: string): Observable<IPDQResponse> {
    value = value.replace(/\r?\n/g, '\r');
    const pdq: IPDQRequest = {
      ip: ip,
      port: port,
      message: btoa(value),
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.post<IPDQResponse>(
      `${environment.BACKEND_URL}PDQv2/SendSingle/ITI22`,
      pdq,
      {
        headers,
      }
    );
  }

  pdqv3(formData: FormData): Observable<string> {
    return this._http.post<string>(
      `${environment.BACKEND_URL}PDQv3/SendSingle`,
      formData,
      {
        responseType: 'text' as 'json',
      }
    );
  }

  pdqm(
    ip: string,
    port: number,
    value: string,
    isXml: boolean = false
  ): Observable<IPDQmResponse | string> {
    const pdq: IPDQRequest = {
      ip: ip,
      port: port,
      message: btoa(value),
    };

    if (isXml) {
      // return XML as raw text
      return this._http.post(
        `${environment.BACKEND_URL}PDQm/SendQueryRaw`,
        pdq,
        {
          responseType: 'text' as const, // 👈 Force-cast to accepted literal
        }
      );
    } else {
      // return JSON as typed object
      return this._http.post<IPDQmResponse>(
        `${environment.BACKEND_URL}PDQm/SendQueryRaw`,
        pdq,
        {
          responseType: 'json',
        }
      );
    }
  }

  runTestQuery(type: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/soap+xml; charset=utf-8',
    });

    return this._http.post(
      `${environment.BACKEND_URL}PDQv3/multi/${type}`,
      null,
      {
        headers,
      }
    );
  }

  fetchNextPage(nextUrl: string) {
    return this._http.post(
      `${environment.BACKEND_URL}PDQm/FetchNextPage`,
      { url: nextUrl },
      { responseType: 'text' } // because it may return raw JSON/XML string
    );
  }

  pdqmRaw(fullUrl: string, isXml: boolean) {
    const headers = {
      Accept: isXml ? 'application/fhir+xml' : 'application/fhir+json',
    };
    return this._http.get(fullUrl, { headers });
  }
}
